module.exports = __webpack_public_path__ + "fonts/fa-light-300.8a4a5bd9264a7880103dba99d57e42ba.eot";